import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getAllTenants, getGetAllTenantsQueryKey, TLTenantStatus } from '@/api/gen';
import { DEFAULT_TENANT_ID } from '@/constants';
import { switchTenantForRouteServerFn } from '@/server/tenants';

export const Route = createFileRoute('/_protected/t/$tenantId')({
  beforeLoad: async ({ params, location, context: { queryClient, tenantId: sessionTenantId } }) => {
    const urlTenantId = params.tenantId;

    if (urlTenantId === DEFAULT_TENANT_ID) {
      throw redirect({ to: '/' });
    }

    if (urlTenantId === sessionTenantId) {
      return { tenantId: urlTenantId };
    }

    const tenants = await queryClient.ensureQueryData({
      queryKey: getGetAllTenantsQueryKey(),
      queryFn: ({ signal }) => getAllTenants(undefined, undefined, signal),
    });
    const target = tenants?.find((t) => t.tenant_id === urlTenantId);
    if (!target || target.status === TLTenantStatus.DELETED) {
      throw redirect({ to: '/' });
    }

    // Drop the entire query cache before the redirect so the next render of
    // the route tree doesn't briefly serve cross-tenant data.
    queryClient.clear();

    // Server fn updates the session cookie and throws a redirect to the
    // requested URL with `Set-Cookie` on the redirect response. After the
    // redirect, `_protected.tsx`'s beforeLoad re-reads the (now-updated)
    // session and the layout's `urlTenantId === sessionTenantId` short-
    // circuit above hits, so this never returns control here on a real
    // switch — the early return below covers the defensive no-op case.
    await switchTenantForRouteServerFn({
      data: { tenant_id: urlTenantId, redirect_to: location.href },
    });

    return { tenantId: urlTenantId };
  },
  component: TenantLayout,
});

function TenantLayout() {
  return <Outlet />;
}
